import React from "react";
import { Outlet } from "react-router-dom";

const Web2layout = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default Web2layout;
